module.exports = __webpack_public_path__ + "static/media/header-background.bb91e48f.png";